import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import axiosInstance from '../functions/AxiosInstance'; // Asegúrate de que la ruta sea correcta

export const useSubmitContact = () => {
  const mutation = useMutation({
    mutationFn: async (contactData: { name: string; email: string; subject: string; message: string }) => {
      const response = await axiosInstance.post('/contacts/', contactData);
      return response.data;
    },
    onSuccess: () => {
      toast.success('Mensaje enviado con éxito.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const errorMessage = error.response?.data?.message || 'Error desconocido';
      toast.error(`Error al enviar el mensaje: ${errorMessage}`);
      console.error('Error al enviar el mensaje:', errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending, // isPending is the correct property for mutations
    isSuccess: mutation.isSuccess,
  };
};




// Función para obtener los contactos
const fetchContacts = async () => {
  const response = await axiosInstance.get('/contacts');
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para listar los contactos
export const useGetContacts = () => {
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['contacts'], // Esto es lo que identifica la consulta en React Query
    queryFn: async () => {
      try {
        return await fetchContacts();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        toast.error(`Error al obtener los contactos: ${error.response?.data?.message || 'Error desconocido'}`);
        console.error('Error al obtener los contactos:', error);
        throw error;
      }
    },
    refetchOnWindowFocus: false, // Opcional: Evita que los datos se vuelvan a obtener cuando el foco de la ventana cambia
  });

  return {
    contacts: data,    // Los datos obtenidos
    isLoading,         // Si está cargando
    isError,           // Si hubo un error
    error,             // El error completo (si existe)
  };
};



// Función para obtener los contactos de usuario
const fetchUserContacts = async () => {
    const response = await axiosInstance.get('/contacts/user');
    return response.data; // Devuelve los datos de la respuesta
  };
  
  // Hook para listar los contactos de usuario
  export const useGetUserContacts = () => {
    const { data, error, isLoading, isError } = useQuery({
      queryKey: ['userContacts'], // Esto es lo que identifica la consulta en React Query
      queryFn: async () => {
        try {
          return await fetchUserContacts();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          toast.error(`Error al obtener los contactos del usuario: ${error.response?.data?.message || 'Error desconocido'}`);
          console.error('Error al obtener los contactos del usuario:', error);
          throw error;
        }
      },
      refetchOnWindowFocus: false, // Opcional: Evita que los datos se vuelvan a obtener cuando el foco de la ventana cambia
    });
  
    return {
      userContacts: data,    // Los datos obtenidos
      isLoading,             // Si está cargando
      isError,               // Si hubo un error
      error,                 // El error completo (si existe)
    };
  };




// Función para eliminar un contacto
const deleteContact = async (contactId: string) => {
  const response = await axiosInstance.delete(`/contacts/${contactId}`);
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para eliminar un contacto
export const useDeleteContact = () => {
  const mutation = useMutation({
    mutationFn: deleteContact, // Función para eliminar el contacto
    onSuccess: () => {
      toast.success('Contacto eliminado con éxito.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const errorMessage = error.response?.data?.message || 'Error desconocido';
      toast.error(`Error al eliminar el contacto: ${errorMessage}`);
      console.error('Error al eliminar el contacto:', errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending, // isPending es la propiedad correcta para mutaciones
    isSuccess: mutation.isSuccess,
  };
};
